export const authEmailNormaliser = <T extends string | null | undefined>(email: T) =>
  email ? email.trim().toLowerCase() : email;
